<template>
  <div class="sub-gnb-back flex flex-space-between flex-align-center">
    <nuxt-img
      v-if="withBack"
      class="ml-16"
      src="/icons/outline/chevron-left.svg"
      height="24"
      width="24"
      alt="back"
      @click="handleBack"
    />
    <div class="flex-auto" />
    <el-text
      v-if="title"
      class="title"
    >
      {{ title }}
    </el-text>
    <div class="flex-auto" />
    <nuxt-img
      v-if="withClose"
      class="mr-16"
      src="/img/basic-icon/close-black.svg"
      width="16"
      height="16"
      alt="close"
      @click="handleClose"
    />
  </div>
</template>

<script setup lang="ts">
import { useBack } from '@/uComposables/_common/navigation'
const { routeBack } = useBack()

const props = withDefaults(
  defineProps<{
    backUrl?: string
    partnersKey?: string
    redirectRoot?: boolean
    withBack?: boolean
    withClose?: boolean
    title?: string
    appStandalone?: boolean
  }>(),
  {
    backUrl: undefined,
    partnersKey: '',
    redirectRoot: false,
    withBack: true,
    title: '',
    appStandalone: false
  }
)

const emit = defineEmits(['clickClose'])

const handleBack = () => {
  if (window.flutter_inappwebview && props.appStandalone) {
    window.flutter_inappwebview.callHandler('closeWebview')
    return
  }
  routeBack(props.backUrl, props.redirectRoot, props.partnersKey)
}

const handleClose = () => {
  if (window.flutter_inappwebview && props.appStandalone) {
    window.flutter_inappwebview.callHandler('closeWebview')
    return
  }
  emit('clickClose')
}
</script>

<style scoped lang="scss">
.sub-gnb-back {
  background-color: $base-white;
  height: 56px;
  width: 100%;
  max-width: 500px;
  .title {
    @include body3-semibold;
    margin-left: 32px;
  }
}
</style>
